import { getRequest } from "./index";

export const getAllRoles = () => {
  const url = "/roles";
  return getRequest(url)
};

